const fulfillmentOrdersGroupByOptions = [
	{
		value: 'orderChannel',
		label: 'Channel',
	},
	{
		value: 'productSku',
		label: 'SKU',
	},
	{
		value: 'warehouse',
		label: 'Warehouse',
	},
	{
		value: 'carrierService',
		label: 'Requested Service',
	},
	{
		value: 'fulfillmentOrderStatus',
		label: 'Status',
	},
	{
		value: 'fulfillmentOrderShipByLocalDate',
		label: 'Ship by Date',
	},
];

export { fulfillmentOrdersGroupByOptions };
